export default "__VITE_ASSET__DvQmsPPo__"